import type { dataHubTheme } from '$lib/api/rpc';
import { cssVars } from '$lib/utils/cssVars';

export const globalCssFromBE = (theme: dataHubTheme) => {
	const fonts = getFonts(theme);
	return cssVars({
		collectionsBackgroundColor: theme.collectionsBackgroundColor,
		collectionsFontColor: theme.collectionsFontColor,
		coverBackgroundColor: theme.coverBackgroundColor,
		coverFontColor: theme.coverFontColor,
		coverHideCover: theme.coverHideCover,
		coverShowTitle: theme.coverShowTitle,
		coverTintColorWithOpacity: theme.coverTintColorWithOpacity,
		coverTintOpacity: theme.coverTintOpacity,
		footerBackgroundColor: theme.footerBackgroundColor,
		footerFontColor: theme.footerFontColor,
		headerAccentColor: theme.headerAccentColor,
		headerBackgroundColor: theme.headerBackgroundColor,
		headerBackgroundOpacity: theme.headerBackgroundOpacity,
		headerCentreLogo: theme.headerCentreLogo,
		headerFontColor: theme.headerFontColor,
		headerIconColor: theme.headerIconColor,
		headerLogoImage: theme.headerLogoImage,
		hubAccentColor: theme.hubAccentColor,
		hubBodyFont: fonts.hubBodyFont,
		hubBodyFontColor: theme.hubBodyFontColor,
		hubBodyFontFamily: theme.hubBodyFontFamily,
		hubBodyFontLetterSpacing: theme.hubBodyFontLetterSpacing,
		hubBodyFontStyle: theme.hubBodyFontStyle,
		hubBodyFontWeight: theme.hubBodyFontWeight,
		hubDetailFont: fonts.hubDetailFont,
		hubDetailFontColor: theme.hubDetailFontColor,
		hubDetailFontFamily: theme.hubDetailFontFamily,
		hubDetailFontLetterSpacing: theme.hubDetailFontLetterSpacing,
		hubDetailFontStyle: theme.hubDetailFontStyle,
		hubDetailFontWeight: theme.hubDetailFontWeight,
		hubHeadlineFont: fonts.hubHeadlineFont,
		hubHeadlineFontColor: theme.hubHeadlineFontColor,
		hubHeadlineFontFamily: theme.hubHeadlineFontFamily,
		hubHeadlineFontLetterSpacing: theme.hubHeadlineFontLetterSpacing,
		hubHeadlineFontStyle: theme.hubHeadlineFontStyle,
		hubHeadlineFontWeight: theme.hubHeadlineFontWeight,
		hubLinkFontColor: theme.hubLinkFontColor,
		hubMenuFont: fonts.hubMenuFont,
		hubMenuFontFamily: theme.hubMenuFontFamily,
		hubMenuFontLetterSpacing: theme.hubMenuFontLetterSpacing,
		hubMenuFontStyle: theme.hubMenuFontStyle,
		hubMenuFontWeight: theme.hubMenuFontWeight,
		hubPostTileFooterFontSize: theme.accessibility ? '1.9rem' : '1.3rem',
		streamAutoplay: theme.streamAutoplay,
		streamBackgroundColor: theme.streamBackgroundColor,
		streamIconColor: theme.streamIconColor,
		streamTileBackdropColor: theme.streamTileBackdropColor,
		streamUseTiles: theme.streamUseTiles,
		...(theme.accessibility && {
			darkenedPrimaryAccentColor: 'rgb(4 66 112)',
			darkenedSecondaryAccentColor: 'rgb(23 29 36)',
		}),
	});
};
export function getFonts(theme: dataHubTheme) {
	type fontName =
		| 'hubBodyFontFamily'
		| 'hubDetailFontFamily'
		| 'hubHeadlineFontFamily'
		| 'hubMenuFontFamily';

	const fontFamilyConstructor = (fontName: fontName) => {
		const fallbackFonts = `'Droid Sans', 'Helvetica Neue', Arial, sans-serif`;
		const fontTheme = theme[fontName] || '';
		return `${fontTheme}, ${fallbackFonts}`;
	};
	return {
		//Every font is initialized to 16px, the font shorthand requires a size
		hubHeadlineFont: `${theme.hubHeadlineFontStyle || ''} ${
			theme.hubHeadlineFontWeight
		} 16px ${fontFamilyConstructor('hubHeadlineFontFamily')}`,

		hubMenuFont: `${theme.hubMenuFontStyle} ${theme.hubMenuFontWeight} 16px ${fontFamilyConstructor(
			'hubMenuFontFamily'
		)}`,

		hubBodyFont: `${theme.hubBodyFontStyle} ${theme.hubBodyFontWeight} 16px ${fontFamilyConstructor(
			'hubBodyFontFamily'
		)}`,

		hubDetailFont: `${theme.hubDetailFontStyle} ${
			theme.hubDetailFontWeight
		} 16px ${fontFamilyConstructor('hubDetailFontFamily')}`,
	};
}
